/* eslint-disable vue/no-parsing-error */
<template>
  <div class="frm-wrap">
    <modal class="modalUpload" name="upload">
      <form class="m-4" @submit.prevent="loadExploreData">
        <div class="mb-3">
          <label for="slectedJson" class="form-label">Upload data(JSON)</label>
          <input
            class="form-control form-control-sm"
            id="slectedJson"
            type="file"
          />
        </div>
        <button class="btn btn-primary" type="submit">Load</button>
      </form>
    </modal>
    <div v-if="this.$store.state.groupMode" class="group-operation">
      <div class="d-flex justify-content-between">
        <h4>Group Operation</h4>
        <div class="form-check form-switch">
          <input
            role="button"
            class="form-check-input"
            type="checkbox"
            v-model="groupMode"
            id="flexSwitchCheckChecked"
            checked
          />
        </div>
      </div>
      <div class="group-operation__icon--box">
        <box-icon
          title="Delete items"
          class="group-operation__icon box-icon box-icon--effect"
          @click="deleteSelectedNodes"
          name="trash"
        ></box-icon>
        <box-icon
          title="Create combo"
          class="group-operation__icon box-icon box-icon--effect"
          :class="getActiveGroup('combo') ? 'box-icon--active' : ''"
          @click="addComboEvent"
          name="message-rounded-add"
        ></box-icon>
        <box-icon
          title="Create node"
          class="group-operation__icon box-icon box-icon--effect"
          :class="getActiveGroup('node') ? 'box-icon--active' : ''"
          @click="addNodeEvent"
          name="message-square-add"
        ></box-icon>
        <box-icon
          title="write query"
          class="group-operation__icon box-icon box-icon--effect"
          :class="getActiveGroup('query') ? 'box-icon--active' : ''"
          @click="addQueryEvent"
          name="git-branch"
        ></box-icon>
        <box-icon
          title="Add hull"
          name="palette"
          class="group-operation__icon box-icon box-icon--effect"
          :class="getActiveGroup('hull') ? 'box-icon--active' : ''"
          @click="addHull"
        ></box-icon>
      </div>
      <div v-if="toggleGroupForm" class="group-operation__form">
        <form @submit.prevent="sendCreation">
          <!-- <input v-if="(groupObj.type !== 'query') && (groupObj.type !== 'hull')"
            type="text"
            class="input-wrap"
            :placeholder="groupObj.label"
            v-model="currentLabel"
          /> -->
          <ed-input
            v-if="groupObj.type !== 'query' && groupObj.type !== 'hull'"
            class="my-3"
            :onChange="setCurrentLabel"
            :placeholder="groupObj.label"
          />
          <color-picker
            class="my-3"
            v-if="groupObj.type === 'hull'"
            v-model="colors"
          />
          <!-- Textarea for query -->
          <textarea
            v-if="groupObj.type === 'query'"
            class="form-control mb-3"
            :placeholder="groupObj.label"
            rows="9"
            v-model="currentQuery"
          ></textarea>
          <!-- Only for node -->
          <!-- <input
            v-if="groupObj.isRelationShip"
            type="text"
            class="input-wrap"
            placeholder="Enter name of relationship"
            v-model="currentEdgeLabel"
          /> -->
          <ed-input
            v-if="groupObj.isRelationShip"
            class="my-3"
            :onChange="setcurrentEdgeLabel"
            placeholder="Enter name of relationship"
          />
          <button type="submit" class="ed-btn__blim">Create</button>
          <input type="file" accept=".csv" @change="changeCsvData">
          <button type="submit" @click="uploadData" class="ed-btn__blim">Upload</button>
        </form>
      </div>
      <div class="mt-2">
        <div class="alert alert-warning" role="alert">
          <strong>Warning:</strong> Group operation is in development mode right
          now.
        </div>

        <!-- Temporary Item -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Important Note :-
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <ol>
                <li>
                  use <span class="badge bg-secondary">shift + mouse</span> to
                  activate selection tool
                </li>
                <br />
                <li>
                  you can also select mutliple nodes with
                  <span class="badge bg-secondary">`Ctrl`</span>(Only works in
                  defualt mode)
                </li>
                <br />
                <li>
                  Creating combo is not working as expected. So, once you've
                  created new combo after selecting multiple nodes, then you
                  will have to drag at least one of the nodes inside the new
                  combo.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.$store.state.groupMode === false" class="group-operation">
      <div class="d-flex justify-content-between">
        <h4>Node Operation</h4>
        <div class="form-check form-switch">
          <input
            role="button"
            class="form-check-input"
            type="checkbox"
            v-model="groupMode"
            id="flexSwitchCheckChecked"
            checked
          />
        </div>
      </div>
      <div class="controller-box">
        <div class="controller" v-for="item in inputRadioList" :key="item.id">
          <input
            type="radio"
            :id="item.id"
            :value="item.id"
            class="controller__input-button"
            :checked="item.isSelected"
            v-model="picked"
            role="button"
          />
          <!-- <box-icon
            :name="item.icon"
            class="controller__icon"
            :title="item.label"
            :class="item.isSelected ? 'controller__icon--active' : ''"
            @click="clickedEvent(item.id)"
          /> -->
          <i
            :class="`${
              item.isSelected
                ? 'controller__icon controller__icon--active'
                : 'controller__icon'
            } bx bx-${item.icon}`"
            :title="getShortcut(item.label, item.id)"
            @click="clickedEvent(item.id)"
          ></i>
          <!-- <label :for="item.id">{{ item.label }}</label> -->
        </div>
        <div class="controller">
          <!-- <box-icon
            name="doughnut-chart"
            @click="toggleGraphConfigs"
            title="Graph Configs"
            :class="graphConfigs ? 'controller__icon--active' : ''"
            class="controller__icon"
          ></box-icon> -->
          <i
            :class="`${
              graphConfigs
                ? 'controller__icon controller__icon--active'
                : 'controller__icon'
            } bx bx-doughnut-chart`"
            title="Graph Configs"
            @click="toggleGraphConfigs"
          ></i>
        </div>
      </div>
      <hr />
      <div class="group-operation__icon--box">
        <i
          name="anchor"
          @click="toggleEdgeMap"
          title="See Relations"
          :class="edgeMap ? 'box-icon--active' : ''"
          class="box-icon box-icon--effect bx bx-anchor"
        ></i>
      </div>

      <div class="mt-3">
        <label for="nodeSize" class="form-label ed-label"
          >Set search depth</label
        >
        {{ getCurrentRange }}
        <input
          type="range"
          min="0"
          max="100"
          v-model="rangeData"
          class="form-range ed-slider"
          id="nodeSize"
        />
      </div>
      <div class="mb-3" v-if="graphConfigs">
        <GraphConfig />
      </div>

      <!-- Condition based elements -->
      <div v-if="this.$store.state.edit_mode === 'add_nodes'">
        <span class="search_wrap">Node Label</span>
        <ed-input
          :onChange="setNodeLabelName"
          placeholder="Label name of your Node"
        />
      </div>

      <div v-else-if="this.$store.state.edit_mode === 'add_relationships'">
        <span class="search_wrap">Edge Label</span>
        <ed-input :onChange="setEdgeLabel" placeholder="Label of your Edge" />
      </div>

      <div v-else>
        <div class="mb-3">
          <span class="search_wrap ed-label">Save As</span>
          <edInput :onChange="setGraphName" placeholder="Name of the Graph" />
        </div>
        <div class="mb-3">
          <label class="ed-label">Choose a Category</label>
          <ed-dropdown
            :selected="selectedCategories"
            :listItems="categories"
            :isSelected="selectCategory"
          />
          <!-- <select
            class="form-select form-select-sm select-cat"
            aria-label="Select Categories"
            v-model="selectedCategories"
            title="Select Category"
          >
            <option
              class="select-cat__option"
              v-for="category in categories"
              :value="category"
              :key="category"
            >
              {{ category }}
            </option>
          </select> -->
        </div>
        <div class="mb-3">
          <span class="ed-label">Tags</span>
          <edInput
            :onChange="setTags"
            placeholder="e.g. Music, Sitar, Entertainment"
          />
        </div>
        <div class="mb-3">
          <button class="ed-btn__blim" @click="saveMyGraph">Save Graph</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import graphReactor from '@/graphReactor';
import graphParse from '@/plugins/graphParse';
import GraphConfig from '@/components/GraphConfig.vue';
import { uniqueIdGenerate } from '@/utils/reuse';
import exploreOps from '@/utils/exploreOps';
import fetchShortcut from '../plugins/fetchShortcut';
import graphFunc from '../utils/queryGenerator';
import smartQueryMode from '../utils/smartQueryMode';
import edInput from './ed-forms/ed-input.vue';
import edDropdown from './ed-forms/ed-dropdown.vue';

export default {
  components: {
    edInput,
    edDropdown,
    GraphConfig,
  },
  data() {
    return {
      tags: '',
      selectedCategories: 'Uncategorized',
      file: null,
      categories: [
        'Science',
        'Technology & Gadgets',
        'Entertainment & Media',
        'Business',
        'Games & Sports',
        'Art & Culture',
        'Educational',
        'Travel - Holidays, Places',
        'Food & Drinks',
        'History & Events',
        'Finances',
        'Health & Wellbeing',
        'Uncategorized',
      ],
      edgeMap: false,
      groupMode: false,
      colors: '',
      picked: 'node_operation',
      graph_name: '',
      rangeData: 0,
      edgeStrength: 0,
      nodeLabelName: '',
      edgeLabelName: '',
      queryMode: 'normal',
      currentQuery: '',
      finalQuery: '',
      currentLabel: '',
      currentEdgeLabel: '',
      groupObj: { type: 'none', label: 'node' },
      toggleGroupForm: false,
      activeTab: 'edge-strength',
      inputRadioList: [
        {
          id: 'node_operation',
          label: 'Node Operation',
          icon: 'pointer',
          isSelected: true,
        },
        {
          id: 'explore',
          label: 'Explore',
          icon: 'search-alt',
          isSelected: false,
        },
        {
          id: 'add_nodes',
          label: 'Add Nodes',
          icon: 'add-to-queue',
          isSelected: false,
        },
        {
          id: 'add_relationships',
          label: 'Add RelationShips',
          icon: 'shape-polygon',
          isSelected: false,
        },
        {
          id: 'remove',
          label: 'Remove',
          icon: 'x-circle',
          isSelected: false,
        },
        {
          id: 'hide_related_nodes',
          label: 'Hide Related Nodes',
          icon: 'hide',
          isSelected: false,
        },
        {
          id: 'show_related_nodes',
          label: 'Show related nodes',
          icon: 'show',
          isSelected: false,
        },
        {
          id: 'hide',
          label: 'Hide',
          icon: 'ghost',
          isSelected: false,
        },

        {
          id: 'lock',
          label: 'Lock',
          icon: 'lock',
          isSelected: false,
        },
        {
          id: 'hsl',
          label: 'Highlight and Select',
          icon: 'selection',
          isSelected: false,
        },
        {
          id: 'combo_explore',
          label: 'Fetch thoughtmap',
          icon: 'cloud-drizzle',
          isSelected: false,
        },
        {
          id: 'combo_expand_collapse',
          label: 'Expand/Collapse thoughtmap',
          icon: 'expand',
          isSelected: false,
        },
        {
          id: 'shortest_path',
          label: 'Shortest Path',
          icon: 'trip',
          isSelected: false,
        },
        {
          id: 'clear_graph',
          label: 'Clear canvas',
          icon: 'brush-alt',
          isSelected: false,
        },
      ],
      graphConfigs: false,
    };
  },
  computed: {
    stateEdgeMap() {
      return this.$store.state.isEdgeMap;
    },
    getUploadingStatus() {
      return this.$store.state.isUploadingData;
    },
    getCurrentRange() {
      return this.$store.state.explore_data_range;
    },
    getEdgeStrength() {
      return this.$store.state.edge_strength;
    },
    getStateMode() {
      return this.$store.state.edit_mode;
    },
    getStateGroupMode() {
      return this.$store.state.groupMode;
    },
  },

  mounted() {
    this.rangeData = this.getCurrentRange;
    this.edgeStrength = this.getEdgeStrength;
    this.edgeMap = this.stateEdgeMap;
  },

  watch: {
    edgeMap(newVal) {
      this.$store.dispatch('setEdgeValue', newVal);
    },
    getUploadingStatus() {
      this.$modal.show('upload');
    },
    groupMode(val) {
      this.$store.dispatch('toggleGroupMode', val);
    },
    getStateGroupMode(val) {
      this.groupMode = val;
    },
    getStateMode() {
      this.picked = this.getStateMode;
    },
    rangeData(val) {
      this.$store.dispatch('setRangeValue', val);
    },
    edgeStrength(val) {
      this.$store.dispatch('setEdgeStrength', val);
    },
    picked(newVal) {
      console.log('picked: ', newVal);
      this.clickedEvent(newVal);
      this.$store.dispatch('setEditMode', newVal);
    },
    nodeLabelName(val) {
      this.$store.dispatch('setNodeLabel', val);
    },
    edgeLabelName(val) {
      this.$store.dispatch('setEdgeLabel', val);
    },
  },

  methods: {
    getActiveGroup(type) {
      return type === this.groupObj.type;
    },

    changeCsvData(e) {
      // eslint-disable-next-line prefer-destructuring
      this.file = e.target.files[0];
      console.log('file: ', this.file);
    },

    async uploadData() {
      const fr = new FileReader();
      fr.onload = async (e) => {
        console.log('e: ', e.target.result);

        // eslint-disable-next-line new-cap
        const parsedGraphData = new graphParse(e.target.result).parse();

        if (parsedGraphData.type === 'nodeEdgeList') {
          this.$store.dispatch('gmodule/csvDataExpand', parsedGraphData.data);
        } else if (parsedGraphData.type === 'comboPropList') {
          console.log('parsedGraphData: ', parsedGraphData);
          this.$store.dispatch('gmodule/comoPropOperation', parsedGraphData.data);
        }
      };
      fr.readAsText(this.file);
    },

    loadExploreData() {
      const { files } = document.getElementById('slectedJson');
      const fr = new FileReader();
      fr.onload = (e) => {
        const result = JSON.parse(e.target.result);
        console.log('result: ', result);
        this.$store.dispatch('gmodule/setExploreData', result);
      };
      fr.readAsText(files[0]);
      this.$modal.hide('upload');
    },

    async saveMyGraph() {
      const payloadObj = {
        graph_name: this.graph_name,
        gdata: graphReactor.exploreInstance.save(),
        graph_type: [this.selectedCategories],
        graph_tags: this.tags,
      };
      await this.$store.dispatch('saveCurrentGraph', payloadObj);
      this.graph_name = '';
      this.tags = '';
      this.selectedCategories = 'Uncategorized';
    },

    sendCreation() {
      if (this.groupObj.type === 'combo') {
        this.$root.$emit('combo-create-select', this.currentLabel);
        this.toggleGroupForm = false;
        console.log('combo created');
      } else if (this.groupObj.type === 'node') {
        const payload = {
          currentLabel: this.currentLabel,
          currentEdgeLabel: this.currentEdgeLabel,
        };
        this.$root.$emit('node-create-select', payload);
        console.log('node created');
        this.toggleGroupForm = false;
      } else if (this.groupObj.type === 'query') {
        this.queryOperation();
      } else if (this.groupObj.type === 'hull') {
        this.creatHullOperation();
      }
    },

    creatHullOperation() {
      const nodes = graphReactor.exploreInstance.findAllByState(
        'node',
        'selected',
      );
      console.log('nodes: ', nodes);
      const id = uniqueIdGenerate('hull');

      const hull = graphReactor.exploreInstance.createHull({
        id,
        type: 'bubble',
        members: nodes,
        padding: 10,
        style: {
          fill: this.colors.hex8,
          stroke: 'green',
        },
      });
      // eslint-disable-next-line
      graphReactor.exploreInstance.on("afterupdateitem", (e) => {
        hull.updateData(hull.members);
      });
    },

    deleteSelectedNodes() {
      this.toggleGroupForm = false;
      this.$root.$emit('delete-selected-nodes');
    },

    queryOperation() {
      // Check whether query starts with mode: keyword if yes then assign it to queryMode
      if (this.currentQuery.startsWith('mode:')) {
        console.log(this.currentQuery.match(/mode:\w+/g));
        const replaceWord = this.currentQuery.match(/mode:\w+/g)[0];
        // eslint-disable-next-line prefer-destructuring
        this.queryMode = replaceWord.split(':')[1];
        console.log(this.queryMode);
        this.finalQuery = this.currentQuery.replace(replaceWord, '');
      } else {
        this.queryMode = 'normal';
        this.finalQuery = this.currentQuery;
      }
      const edEmbed = `$ed ${this.finalQuery} ed$`; // embedding $ed to distinguish from other queries
      const sanitizedQuery = graphFunc.filterQuery(edEmbed); // sanitize query: it will break this into an array
      const queryObj = {
        type: this.queryMode, // mode
        query: sanitizedQuery, // query
      };
      console.log('there shold ', sanitizedQuery);
      const resultPayload = graphFunc.filterResult(queryObj);
      // console.log('node edge list', resultPayload);

      if (this.queryMode === 'normal') {
        exploreOps.queryOperation(resultPayload);
      } else if (this.queryMode === 'smart') {
        const globalOperations = smartQueryMode(this.finalQuery);
        if (globalOperations.createList !== undefined) {
          console.log('createList', globalOperations.createList);
          exploreOps.queryOperation(globalOperations.createList);
        }
      } else {
        console.log('query-operation', this.queryMode);
      }
    },

    addComboEvent() {
      this.toggleGroupForm = true;
      this.groupObj = {
        type: 'combo',
        label: 'Enter name of combo',
      };
    },

    addQueryEvent() {
      this.toggleGroupForm = true;
      this.groupObj = {
        type: 'query',
        label: 'Enter your query',
      };
    },

    addHull() {
      this.toggleGroupForm = true;
      this.groupObj = {
        type: 'hull',
        label: 'Enter name of hull',
      };
    },

    addNodeEvent() {
      this.toggleGroupForm = true;
      this.groupObj = {
        type: 'node',
        label: 'Enter name of node',
        isRelationShip: true,
      };
    },

    activateTab(name) {
      this.activeTab = name;
    },

    activeClassName(name) {
      return { active: this.activeTab === name };
    },

    activeTabClass(name) {
      return { show: this.active === name, active: this.active === name };
    },

    clickedEvent(id) {
      console.log(id);
      // eslint-disable-next-line
      const newControllers = this.inputRadioList.map((control) => {
        const temp = control;
        if (temp.id === id) {
          this.picked = id;
          temp.isSelected = true;
        } else {
          temp.isSelected = false;
        }
        return temp;
      });
      this.inputRadioList = newControllers;
    },
    selectCategory(tab) {
      this.selectedCategories = tab;
    },
    setGraphName(val) {
      console.log(val);
      this.graph_name = val;
    },
    setTags(val) {
      this.tags = val;
    },
    setCurrentLabel(val) {
      this.currentLabel = val;
    },
    setcurrentEdgeLabel(val) {
      this.currentEdgeLabel = val;
    },
    setSelectedGraphConfig(tab) {
      this.selectedGraphConfig = tab;
      this.graphConfigList = this.graphConfigList.map((each) => {
        const myTab = each;
        if (myTab.label === tab) {
          if (myTab.isSelected === true) {
            myTab.isSelected = false;
            this.selectedGraphConfig = '';
          } else {
            myTab.isSelected = true;
          }
        } else {
          myTab.isSelected = false;
        }
        return myTab;
      });
    },
    setNodeLabelName(value) {
      this.nodeLabelName = value;
    },
    setEdgeLabel(value) {
      this.edgeLabelName = value;
    },
    toggleEdgeMap() {
      this.edgeMap = !this.edgeMap;
    },
    toggleGraphConfigs() {
      this.graphConfigs = !this.graphConfigs;
    },
    getShortcut(label, _key) {
      return fetchShortcut(label, _key);
    },
    // fetchShortcut(_key) {
    //   const val = universalMap.filter((eachMap) => eachMap.mode_name === _key);
    //   if (val.length > 0) {
    //     return val[0].hotKey;
    //   }
    //   return '';
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/abstracts/variables";
@import "../scss/mixins";
@import "../scss/components/ed-slider";

.modalUpload {
  color: black;
}

.select-cat {
  width: auto;
  text-transform: uppercase;
  font-weight: bold;
  border: none;
  padding: 0.5em;
  border-radius: 0.3125em;
  transition: all ease-in-out 200ms;

  &:hover {
    background-color: $edvantaButtonColor;
    cursor: pointer;
  }

  &:focus,
  &:active {
    outline: none;
    border: none;
    box-shadow: none;
  }
}

.slider-div {
  background-color: $lightGray;
  padding: 0.625em;

  .nav-tabs {
    overflow-x: auto;
    overflow-y: hidden;
    @include custom-scroll-bar;

    .nav-link {
      white-space: nowrap;
      color: $edvantaBlue;
    }
  }
}
.rd_content {
  margin-right: 0.75em;
}
.frm-wrap {
  padding: 0.5em 0.1875em;
  text-transform: capitalize;
  width: 100%;
}
span.search_wrap {
  display: inline-block;
  margin-right: 1.5em;
}
input.text_bar {
  border-radius: 0.3rem;
  border: none;
  border: 0.0625em solid gray;
  width: 100%;
}
button.btn_bar {
  margin-top: 1em;
  border-radius: 0.25em;
  background-color: $edvantaBlue;
  color: #fff;
  margin-right: 0.625em;
}
.controller-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.controller {
  display: flex;
  margin: 0.3rem;
  cursor: pointer;

  &__input-button {
    display: none;
  }

  &__icon {
    fill: $color-grey-1;
    color: $color-grey-1;
    // padding: 0.1rem;
    transition: all 0.3s ease-in;
    border-radius: 1rem;
    font-size: 1.5rem;

    &:hover {
      fill: $secondaryBlue;
      color: $secondaryBlue;
      background: rgba($color-grey-2, 0.5);
    }

    &--active,
    &--active:hover {
      fill: $edvantaBlue;
      color: $edvantaBlue;
      // background: $secondaryBlue;
      // background: rgb(0, 132, 255);
    }
  }
}

.max-wrap {
  width: 100%;
}
</style>
